import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationAxoFiConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Axo Finance Oy',
    number: '2984343-1',
    address: {
      streetAddress: 'Kalevankatu 6 4 krs',
      addressLocality: 'Helsinki',
      postalCode: '00100',
      addressCountry: 'FI',
    },
  },
};
